import * as yup from 'yup';

export const voucherInsertionSchema = () =>
  yup.object({
    discountCode: yup.string().required('Campo Obbligatorio'),
  });

